import {
  type JobCatalogEnumsJobCatalogTreeNodeTypesEnum,
  NodePageDocument,
  UpdateJobCatalogTreeNodeDocument,
  UpdateJobCatalogTreeNodeMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useUpdateJobCatalogTreeNode = () => {
  const [mutate, { loading }] = useMutation(UpdateJobCatalogTreeNodeDocument, {
    extractorFn: (data: UpdateJobCatalogTreeNodeMutation) =>
      data.jobCatalogMutations.updateJobcatalogTreeNode,
  })

  const updateNode = (
    companyId: number,
    description: string,
    name: string,
    nodeId: number,
    nodeType: JobCatalogEnumsJobCatalogTreeNodeTypesEnum,
    parentId: number
  ) => {
    return mutate({
      variables: {
        companyId,
        description,
        name,
        nodeId,
        nodeType,
        parentId,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeId: nodeId,
            nodeType: nodeType,
            childType: nodeType,
          },
        },
      ],
    })
  }

  return { updateNode, loading }
}

export default useUpdateJobCatalogTreeNode
